"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("../Dataset");
class TokenDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.createToken));
        this.update = (this.sendRequest(interfaces_1.WEN_FUNC.updateToken));
        this.setAvailableForSale = (this.sendRequest(interfaces_1.WEN_FUNC.setTokenAvailableForSale));
        this.cancelPublicSale = (this.sendRequest(interfaces_1.WEN_FUNC.cancelPublicSale));
        this.order = (this.sendRequest(interfaces_1.WEN_FUNC.orderToken));
        this.credit = (this.sendRequest(interfaces_1.WEN_FUNC.creditToken));
        this.mint = (this.sendRequest(interfaces_1.WEN_FUNC.mintTokenOrder));
        this.enableTrading = (this.sendRequest(interfaces_1.WEN_FUNC.enableTokenTrading));
        this.importMintedToken = (this.sendRequest(interfaces_1.WEN_FUNC.importMintedToken));
        this.vote = (this.sendRequest(interfaces_1.WEN_FUNC.voteController));
        this.rank = (this.sendRequest(interfaces_1.WEN_FUNC.rankController));
        this.getByMemberLive = (member, startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['member'],
                fieldValue: [member],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getByStatusLive = (status = [], startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                fieldName: status.map(() => 'status').concat('public'),
                fieldValue: status.concat(true),
                operator: status.map(() => interfaces_1.Opr.EQUAL).concat(interfaces_1.Opr.EQUAL),
                startAfter,
                limit,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.TokenDataset = TokenDataset;
